import { Mapper } from "../../../../../core/base";
import { PlanDetailWebEntity } from "./plan-detail-web-entity";
import { PlanDetails } from "../../../../../core/domain/models/plan-details";

export class PlanDetailWebRepositoryMapper extends Mapper<PlanDetailWebEntity, PlanDetails> {
  mapFrom(param: PlanDetailWebEntity): PlanDetails {
    return {
      planId: param.planId,
      planName: param.planName,
      description: param.description,
      distributionLaneId: param.distributionLaneId,
      distributionLaneName: param.distributionLaneName,
      status : param.status,
      jobs: param.jobs?.map((item) => ({
        jobId: item.jobId,
        jobName: item.jobName,
        jobNumber: item.jobNumber,
        jobColor: item.jobColor,
        endAddress: item.endAddress,
        endLatitude: item.endLatitude,
        endLongitude: item.endLongitude,
        startAddress: item.startAddress,
        startTerminalName: item.startTerminalName,
        endTerminalName: item.endTerminalName,
        startLatitude: item.startLatitude,
        startLongitude: item.startLongitude,  
        vehicleType : item.vehicleType,  
        capacityType1 : item.capacityType1,
        capacityType2 : item.capacityType2,
        capacityType3 : item.capacityType3,       
        locations: item.locations?.map((location) => ({
          address: location.address,
          latitude: location.latitude,
          longitude: location.longitude,
          locationName: location.locationName,
          stopNumber: location.stopNumber,
          stopTime:location.stopTime!,
        })),
        startTime: item.startTime!,
        endTime: item.endTime!
      })),
      isScheduled: param.isScheduled,
      resources: param.resources?.map((resource=>({
        sourceType:resource.sourceType,
        jobResourceDetails: resource.jobResourceDetails?.map((detail)=>({
          vehicleType: detail.vehicleType,
          noOfResource: detail.noOfResource,
          capacityType1 : detail.capacityType1,
          capacityType2 : detail.capacityType2,
          capacityType3 : detail.capacityType3, 
        }))
      })))
    };
  }

  mapTo(param: PlanDetails): PlanDetailWebEntity {
    return {
      planId: param.planId,
      planName: param.planName,
      description: param.description,
      distributionLaneId: param.distributionLaneId,
      distributionLaneName: param.distributionLaneName,
      jobs: param.jobs?.map((item) => ({
        jobId: item.jobId,
        jobName: item.jobName,
        jobNumber: item.jobNumber,
        jobColor: item.jobColor,
        endAddress: item.endAddress,
        endLatitude: item.endLatitude,
        endLongitude: item.endLongitude,
        startAddress: item.startAddress,
        startLatitude: item.startLatitude,
        startTerminalName: item.startTerminalName,
        endTerminalName: item.endTerminalName,
        startLongitude: item.startLongitude,
        capacityType1 : item.capacityType1,
        capacityType2 : item.capacityType2,
        capacityType3 : item.capacityType3,       
        locations: item.locations?.map((location) => ({
          address: location.address,
          latitude: location.latitude,
          longitude: location.longitude,
          locationName: location.locationName,
          stopNumber: location.stopNumber,
          stopTime: location.stopTime!
        })),
        startTime: item.startTime!,
        endTime:item.endTime!
      })),
      isScheduled: param.isScheduled,
      resources: param.resources?.map((resource=>({
        sourceType:resource.sourceType,
        jobResourceDetails: resource.jobResourceDetails?.map((detail)=>({
          vehicleType: detail.vehicleType,
          noOfResource: detail.noOfResource,
          capacityType1 : detail.capacityType1,
          capacityType2 : detail.capacityType2,
          capacityType3 : detail.capacityType3, 
        }))
      })))
    };
  }

}
